<template>
  <div class="col-sm-6 col-md-4 pad_c">
  	<div class="list_card_append">
  		<div class="list_card_append_h" v-if='scenarioId'>
        <h4 class="m-0 fs-12 bold">{{moment(start_date).format('DD MMM YYYY  hh:mm A')}} - {{moment(start_date).add(this.days,'days').format("DD MMM YYYY  hh:mm A")}} <i class="pull-right fs-13 fa fa-lock" v-if='campaign.locked'></i></h4>
        <div class="date_show">
					<a class="datefieldinput fs-13 p-0" v-if='campaign.locked !== 1' data-toggle="modal" :data-target="'#update_campaign_schedule_'+campaign.id">{{ActionsValue}}, After {{campaign.send_after}} {{campaign.send_after_type == 1?"Days":"Hours"}}</a>
					<div class="datefieldinput fs-13 p-0" v-if='campaign.locked == 1'>{{ActionsValue}}, After {{campaign.send_after}} {{campaign.send_after_type == 1?"Days":"Hours"}}</div>
          <div class="vapos">
            <span class="">Validity:</span> 
            <select :disabled='campaign.locked == 1' class="form-control select_field arrow_d" @change="changeday(campaign.id)" v-model="days" style="height: 20px!important;padding:0px!important;min-height: 1px!important;line-height: 20px!important;">
							<option value="1">1 day</option>
							<option value="2">2 days</option>
							<option value="3">3 days</option>
							<option value="4">4 days</option>
							<option value="5">5 days</option>
							<option value="6">6 days</option>
							<option value="7">7 days</option>
							<option value="8">8 days</option>
							<option value="9">9 days</option>
							<option value="10">10 days</option>
						</select>
          </div>
          <span v-if="dateconflicterrormessage==true" class='text-danger'> {{ $t("campaign.bulk_campaign.error_in_date_conflict") }} </span>
        </div>
      </div>
      <div class="list_card_append_h" v-if='!scenarioId'>
        <h4 class="m-0 fs-12 bold">{{moment(start_date).format('DD MMM YYYY  hh:mm A')}} - {{moment(start_date).add(this.days,'days').format("DD MMM YYYY  hh:mm A")}} <i class="pull-right fs-13 fa fa-lock" v-if='campaign.locked'></i></h4>
        <div class="date_show">
          <el-date-picker class="form-control datefieldinput" v-model="start_at" format="dd-MM-yyyy hh:mm A" @change='changeDate(campaign.id)' type="datetime" size="small" placeholder="Change date and time" :picker-options="startDatePickerOptions" :disabled='campaign.locked == 1'>
					</el-date-picker>
          <div class="vapos">
            <span class="">Validity:</span> 
            <select class="form-control select_field arrow_d" :disabled='campaign.locked == 1' @change="changeday(campaign.id)" v-model="days" style="height: 20px!important;padding:0px!important;min-height: 1px!important;line-height: 20px!important;">
							<option value="1">1 day</option>
							<option value="2">2 days</option>
							<option value="3">3 days</option>
							<option value="4">4 days</option>
							<option value="5">5 days</option>
							<option value="6">6 days</option>
							<option value="7">7 days</option>
							<option value="8">8 days</option>
							<option value="9">9 days</option>
							<option value="10">10 days</option>
						</select>
          </div>
          <span v-if="dateerrorblank==true" class='text-danger'>Please Select Date</span>
					<span v-if="dateerrormessage==true" class='text-danger'>{{ $t("campaign.bulk_campaign.error_early_schedule") }}</span>
					<span v-if="dateconflicterrormessage==true" class='text-danger'> {{ $t("campaign.bulk_campaign.error_in_date_conflict") }} </span>
        </div>
      </div>
      <div class="camp_details">
        <div class="camp_img">
          <img alt="Profile Image" :src="campaign.thumbnail">
        </div>
        <span  v-if='campaign.locked !== 1' class="a_color change_btn pointer" @click='changeScenario(campaign.id, campaign.book.id)' data-toggle="modal" data-target="#campaigns_schedule">Change</span>
        <h3 class="thumbnail_title m-0 fs-15" :title="campaign.scenario.name">{{campaign.scenario.name}}</h3>
        <p class="thumbnail_desc m-0 oneline_text">
          <i v-if='campaign.scenario.type == "click"' class="far fa-hand-pointer mr-1"></i>
          <i v-if='campaign.scenario.type == "attachment"' class="fas fa-paperclip mr-1"></i>
					<i v-if='campaign.scenario.type == "data-entry"' class="fas fa-keyboard mr-1"></i>
          <span class="mr-1">{{campaign.scenario.type}}</span>
          <span>Level {{campaign.scenario.level}}</span>
        </p>							
      </div>
      <div class="lesson_box">
        <h6 class="m-0 bold pt-2">Lessons</h6>
        <p class="thumbnail_desc m-0 oneline_text" v-for='(item, index) in campaign.book.chapters'>lesson {{++index}}: {{item.title}}</p>
        <button class="btn hf-btn-info btn-sm  btn_h mt10" type="button" @click='campaign_preview(campaign.id)' v-if="campaign.locked == 1">Preview</button>
					<button class="btn hf-btn-info btn-sm  btn_h mt10" type="button" v-if="campaign.locked !=1" @click='campaign_preview_edit(campaign.id)' >Edit & Preview</button>
      </div>
    </div>
  </div>
</template>

<script>
	export default {

	data() {
		return {
			scenario: {},
			campaignAction: '',
			ActionsValue: '',
			actionArry: [],
			restraninActionArry: [],
			retestActionArry: [],
			start_at: '',
			startDatePickerOptions: {
				disabledDate: (date) => {

					return this.moment(date).isBefore(new Date, 'day');
				}
			},
			bulk_campaign_id: this.$route.params.id,
			sendAfter: '',
			sendAfterType: '',
			campaignAction: '',
			sendAfterError: '',
			campaignActionError: '',
			dateerrormessage: false,
			dateconflicterrormessage: false,
			showEditPopUp: false,
			days: 5,
			start_date: '',
			previewCampaign: []
		}
	},
	props: ['campaign', 'index', 'scenarioId', 'initialStartDate', 'mainCampaignId'],
	watch: {
		initialStartDate: function() {
			this.changeStartEndDate();
		}
	},
	beforeMount() {

		// this.start_at = this.moment(this.campaign.send_at).format('DD MMM YYYY HH:mm A');
		this.start_at = this.campaign.send_at;

		if (this.campaign.end_days) {
			this.days = this.campaign.end_days;
		}

		this.start_date = this.initialStartDate;

		let actionArry = [{
				label: 'All',
				value: '5'
		},{
			label: 'Didn\'t Open',
			value: '1'
		},
		{
			label: 'Didn\'t Click',
			value: '2'
		},
		{
			label: 'Got Lured',
			value: '3'
		},
		{
			label: 'Education Not Taken',
			value: '4'
		}];

		this.retestActionArry = actionArry;
		this.actionArry = actionArry;
		this.restrainActionArry = actionArry;

		if (this.campaign.action && this.campaign.action != "") {
			this.ActionsValue = [];
			_.map(actionArry, (t) => {
				if (this.campaign.action.indexOf(t.value) != -1) {
					this.ActionsValue.push(t.label);
				}
			});
			this.ActionsValue = this.ActionsValue.join(', ');
		}

		if (this.campaign.parent_id) {
			this.sendAfter = this.campaign.send_after;
			this.sendAfterType = this.campaign.send_after_type;
			this.campaignAction = [];
			_.map(actionArry, (t) => {
				if (this.campaign.action.indexOf(t.value) != -1) {
					this.campaignAction.push(t.value);
				}
			});
			this.changeStartEndDate();
		}

		this.$parent.$on('changesOnMainCampaign', function() {
			if (this) {
				this.changeStartEndDate();
			}
		}.bind(this));


		if (this.campaign.id == this.$parent.lastInsertedId) {
			setTimeout(function() {
				this.changeScenario(this.campaign.id, this.campaign.book.id);
			}.bind(this), 1000);
			this.$parent.lastInsertedId = 0;
		}

		let campaignsDetails = JSON.parse(JSON.stringify(this.$parent.campaigns));
		_.map(campaignsDetails,(t)=>{
			if(t.childCampaign ) {
				if(t.childCampaign.id == this.campaign.id) {
					
					if(t.scenario.type === 'announcement') {
						// User can only select all in this campaign
						this.actionArry = [{
							label: 'All',
							value: '5'
						}];
					}
				} else if(t.childCampaign.childCampaign && t.childCampaign.childCampaign.id == this.campaign.id) {
					
					if(t.childCampaign.scenario.type === 'announcement') {
						// User can only select all in this campaign
						this.actionArry = [{
							label: 'All',
							value: '5'
						}];
					}
				}
			}
		});
	},
	methods: {
		editCampaign(id) {
			$('#editCampaign').modal('show');
			this.$http.get('/bulk/campaign/schedule/' + id).then((response) => {
				this.$parent.scenario = response.data.data;
			});
		},
		campaign_preview(campaign_id)
		{
			this.routeHeader = this.$parent.routeHeader;
			this.routePath = this.$parent.routePath;

			this.$router.push({ path: '/bulk_campaign/preview/'+campaign_id })
		},
		campaign_preview_edit(campaign_id)
		{
			this.routeHeader = this.$parent.routeHeader;
			this.routePath = this.$parent.routePath;

			this.$router.push({ path: '/bulk_campaign/preview/edit/'+campaign_id })
		},
		changeStartEndDate() {
			this.start_date = this.initialStartDate;
			if (this.mainCampaignId) {
				let campaigns = this.$parent.campaigns;
				_.map(campaigns, function(val) {
					if (val.id == this.mainCampaignId) {
						// add parent end days
						this.start_date = this.moment(this.start_date).add(val.end_days, 'days');
						// add 1st version days/hours
						if (val.childCampaign.send_after_type == 1) {
							this.start_date = this.moment(this.start_date).add(val.childCampaign.send_after, 'days');
						} else {
							this.start_date = this.moment(this.start_date).add(val.childCampaign.send_after, 'hours');
						}
						if (this.campaign.id !== val.childCampaign.id) {
							// add 1st version end days
							this.start_date = this.moment(this.start_date).add(val.childCampaign.end_days, 'days');
							// add 2nd version days/hours
							if (val.childCampaign.childCampaign.send_after_type == 1) {
								this.start_date = this.moment(this.start_date).add(val.childCampaign.childCampaign.send_after, 'days');
							} else {
								this.start_date = this.moment(this.start_date).add(val.childCampaign.childCampaign.send_after, 'hours');
							}
						}
					}
				}.bind(this));
			}
		},
		changeScenario(id, education_id) {
			this.$parent.campaign_id = id;
			this.$parent.isEdit = true;
			this.$parent.campaignIndex = this.index;
			this.$parent.isChangeCampapaignScenario = true;

			if (this.scenarioId) {
				let data = {
					education_id: [education_id],
					scenario_id: this.scenarioId,
					no_paginate: true
				};
				this.$parent.retest = true;
				// TODO: we will show announcements only in this 
				this.$parent.isAnnouncement = false;
				if(this.campaign.action.indexOf('5') != -1) {
					this.$parent.isAnnouncement = true;
					//data.type = 'announcement';
				}

				var data  = {
					'types': this.$parent.checkedType,
					'methods': this.$parent.checkedMethod,
					'levels': this.$parent.checkedLevel,
					'tags': this.$parent.checkedTag,
				}

				this.$http.post('/library/scenarios/bulkcampaign', data).then((response) => {
					$('#myScenarioModal').modal('show');
					this.$parent.filteredScenarios = response.data.data;
					this.$emit('changesinScenario', this.$parent.filteredScenarios);
				})

				// this.$http.post('/library/scenarios', data).then((response) => {
				//     $('#myScenarioModal').modal('show');
				//     this.$parent.filteredScenarios = response.data.data;
				//     this.$emit('changesinScenario', this.$parent.filteredScenarios);
				// })
			}
			else {
				$('#myModal').modal('show');
				this.$parent.getScenarioDetail(this.type, id);
			}
		},
		changeDate(id) {
			
			if(this.start_at=="")
			{
			  this.dateerrormessage =true;
			  return false;
			}
			this.date = this.moment().diff(this.start_at, 'hours');
			
			if(this.date>(-1))
			{
			  this.dateerrormessage =true;
			  return false;
			}
			this.dateerrormessage = false;
			this.dateconflicterrormessage =false;
			_.map(this.$parent.campaigns,(t)=>{
				if(t.id != id) {
					let beforeTime = this.moment(t.send_at);
					let add_days = parseInt(t.end_days);
					let add_hours = 0;
					if(t.childCampaign && t.childCampaign.send_after && t.childCampaign.send_after_type
					) {
						if(t.childCampaign.send_after_type == 1) {
							add_days += parseInt(t.childCampaign.send_after);
						} else {
							add_hours += parseInt(t.childCampaign.send_after);
						}
						add_days += parseInt(t.childCampaign.end_days);

						if(t.childCampaign.childCampaign && t.childCampaign.childCampaign.send_after && t.childCampaign.childCampaign.send_after_type
						) {
							if(t.childCampaign.childCampaign.send_after_type == 1) {
								add_days += parseInt(t.childCampaign.childCampaign.send_after);
							} else {
								add_hours += parseInt(t.childCampaign.childCampaign.send_after);
							}
							add_days += parseInt(t.childCampaign.childCampaign.end_days);
						}
					}

					let afterTime = this.moment(t.send_at).add(add_days,'day').add(add_hours,'hours');
					if (this.moment(this.start_at).isBetween(beforeTime, afterTime)) {
						this.dateconflicterrormessage =true;
						return false;
					}
				}
			});

			if(this.dateconflicterrormessage == true){
				return;
			}

			// check for end date of this campaign will also not cross with other campaigns
			let campaignsDetails = _.clone(this.$parent.campaigns); 
			let send_at;
			let campaign_id;
			this.dateconflicterrormessage =false;
			let oldCampaign;
			_.map(campaignsDetails,(t)=>{
				if(t.id == id) {
					oldCampaign = _.clone(t);
					t.send_at = this.start_at;
					campaign_id = t.id;  
					send_at = t.send_at;   
				}
			});

			var send_at_end;
			var send_at_start;
			_.map(campaignsDetails,(t)=>{
				if(t.id == campaign_id) {
					let add_days = parseInt(t.end_days);
					let add_hours = 0;
					if(t.childCampaign && t.childCampaign.send_after && t.childCampaign.send_after_type) {
					
						if(t.childCampaign.send_after_type == 1) {
							add_days += parseInt(t.childCampaign.send_after);
						} else {
							add_hours += parseInt(t.childCampaign.send_after);
						}
						add_days += parseInt(t.childCampaign.end_days);
					
						if(t.childCampaign.childCampaign && t.childCampaign.childCampaign.send_after && t.childCampaign.childCampaign.send_after_type
						) {
								if(t.childCampaign.childCampaign.send_after_type == 1) {
									add_days += parseInt(t.childCampaign.childCampaign.send_after);
								} else {
									add_hours += parseInt(t.childCampaign.childCampaign.send_after);
								}
								add_days += parseInt(t.childCampaign.childCampaign.end_days);
						}
					}
					send_at_start = this.moment(t.send_at).format('Y-MM-DD HH:mm:ss');
					send_at_end = this.moment(t.send_at).add(add_days,'day').add(add_hours,'hours').format('Y-MM-DD HH:mm:ss');
				}
			});

			_.map(campaignsDetails,(t)=>{
				if(t.id != campaign_id) {
					let beforeTime = this.moment(t.send_at);
					let add_days = parseInt(t.end_days);
					let add_hours = 0;
					if(t.childCampaign && t.childCampaign.send_after && t.childCampaign.send_after_type
					) {
						if(t.childCampaign.send_after_type == 1) {
							add_days += parseInt(t.childCampaign.send_after);
						} else {
							add_hours += parseInt(t.childCampaign.send_after);
						}
						add_days += parseInt(t.childCampaign.end_days);

						if(t.childCampaign.childCampaign && t.childCampaign.childCampaign.send_after && t.childCampaign.childCampaign.send_after_type
						) {
							if(t.childCampaign.childCampaign.send_after_type == 1) {
								add_days += parseInt(t.childCampaign.childCampaign.send_after);
							} else {
								add_hours += parseInt(t.childCampaign.childCampaign.send_after);
							}
							add_days += parseInt(t.childCampaign.childCampaign.end_days);
						}
					}

					let afterTime = this.moment(t.send_at).add(add_days,'day').add(add_hours,'hours');

					if (this.moment(send_at_end).isBetween(beforeTime, afterTime) || this.moment(send_at_start).isBetween(beforeTime, afterTime) || this.moment(beforeTime).isBetween(send_at_start, send_at_end)) {
						this.dateconflicterrormessage =true;
						return;
					}
				}
			});

			if(this.dateconflicterrormessage == true){
				return;
			}



			
			let data = {
				start_at: this.moment(this.start_at).format("YYYY-MM-DD HH:mm:ss")
			}

			this.$http.post('bulk/campaign/schedule/update/date/' + id, data).then((response) => {
				this.$parent.filteredScenarios = response.data.data;
				this.$parent.$emit('showUpdateSuccessFullMesssage');
			})

			let dateAndID = {
				start_at: this.moment(this.start_at).format("YYYY-MM-DD HH:mm:ss"),
				id: id
			}
			this.$parent.$emit('changeDateFromChild', dateAndID);
		},
		changeday(id) {

			let campaignsDetails = _.clone(this.$parent.campaigns); 
			let send_at;
			let campaign_id;
			this.dateconflicterrormessage =false;
			let oldCampaign;
			_.map(campaignsDetails,(t)=>{
				if(t.id == id) {
					oldCampaign = _.clone(t);
					t.end_days = this.days; 
					campaign_id = t.id;  
					send_at = t.send_at;   
				}
				if(t.childCampaign && t.childCampaign.send_after && t.childCampaign.send_after_type) {
					if(t.childCampaign.id == id) {
						oldCampaign = _.clone(t.childCampaign);
						t.childCampaign.end_days = this.days;
						campaign_id = t.id;  
						send_at = t.send_at;
					}
					if(t.childCampaign.childCampaign && t.childCampaign.childCampaign.send_after && t.childCampaign.childCampaign.send_after_type
					) {
						if(t.childCampaign.childCampaign.id == id) {
							oldCampaign = _.clone(t.childCampaign.childCampaign);
							t.childCampaign.childCampaign.end_days = this.days;
							campaign_id = t.id;  
							send_at = t.send_at;
						}
					}
				}
			});

			var send_at_end;
			_.map(campaignsDetails,(t)=>{
				if(t.id == campaign_id) {
					let add_days = parseInt(t.end_days);
					let add_hours = 0;
					if(t.childCampaign && t.childCampaign.send_after && t.childCampaign.send_after_type) {
					
						if(t.childCampaign.send_after_type == 1) {
							add_days += parseInt(t.childCampaign.send_after);
						} else {
							add_hours += parseInt(t.childCampaign.send_after);
						}
						add_days += parseInt(t.childCampaign.end_days);
					
						if(t.childCampaign.childCampaign && t.childCampaign.childCampaign.send_after && t.childCampaign.childCampaign.send_after_type
						) {
								if(t.childCampaign.childCampaign.send_after_type == 1) {
									add_days += parseInt(t.childCampaign.childCampaign.send_after);
								} else {
									add_hours += parseInt(t.childCampaign.childCampaign.send_after);
								}
								add_days += parseInt(t.childCampaign.childCampaign.end_days);
						}
					}
					send_at_end = this.moment(t.send_at).add(add_days,'day').add(add_hours,'hours').format('Y-MM-DD HH:mm:ss');
				}
			});

			_.map(campaignsDetails,(t)=>{
				if(t.id != campaign_id) {
					let beforeTime = this.moment(t.send_at);
					let add_days = parseInt(t.end_days);
					let add_hours = 0;
					if(t.childCampaign && t.childCampaign.send_after && t.childCampaign.send_after_type
					) {
						if(t.childCampaign.send_after_type == 1) {
							add_days += parseInt(t.childCampaign.send_after);
						} else {
							add_hours += parseInt(t.childCampaign.send_after);
						}
						add_days += parseInt(t.childCampaign.end_days);

						if(t.childCampaign.childCampaign && t.childCampaign.childCampaign.send_after && t.childCampaign.childCampaign.send_after_type
						) {
							if(t.childCampaign.childCampaign.send_after_type == 1) {
								add_days += parseInt(t.childCampaign.childCampaign.send_after);
							} else {
								add_hours += parseInt(t.childCampaign.childCampaign.send_after);
							}
							add_days += parseInt(t.childCampaign.childCampaign.end_days);
						}
					}

					let afterTime = this.moment(t.send_at).add(add_days,'day').add(add_hours,'hours');
					if (this.moment(send_at_end).isBetween(beforeTime, afterTime)) {
						this.dateconflicterrormessage =true;
						return;
					}
				}
			});

			if(this.dateconflicterrormessage == true){
				setTimeout(()=>{
						this.days = oldCampaign.end_days;
						this.dateconflicterrormessage = false;
					},3000);
				return;
			}


			let data = {
				days: this.days,
				id: id
			}
			
			this.$http.post('bulk/campaign/changeday', data).then((response) => {
				let dateAndID = {
					days: this.days,
					id: id
				}
				this.$parent.$emit('showUpdateSuccessFullMesssage');
				this.$parent.$emit('changeDaysFromChild', dateAndID);
			})
		},
		updateCampaignSchedule(id) {
			this.sendAfterError = "";
			this.campaignActionError = "";
			

			if (!this.sendAfter || this.sendAfter < 1) {
				this.sendAfterError = "Please enter valid value in send after.";
			}
			if (this.campaignAction == "") {
				this.campaignActionError = "Please select atleast 1 action.";
			}
			
			if (this.campaignActionError == "" && this.sendAfterError == "") {
				// code to check dates are conflict or not
				let campaignsDetails = _.clone(this.$parent.campaigns); 
				let send_at;
				let campaign_id;
				this.dateconflicterrormessage =false;
				let oldCampaign;
				_.map(campaignsDetails,(t)=>{
					if(t.id == id) {
						oldCampaign = _.clone(t);
						t.send_after = this.sendAfter; 
						t.send_after_type = this.sendAfterType;
						campaign_id = t.id;  
						send_at = t.send_at;
					}
					if(t.childCampaign && t.childCampaign.send_after && t.childCampaign.send_after_type) {
						if(t.childCampaign.id == id) {
							oldCampaign = _.clone(t.childCampaign);
							t.childCampaign.send_after = this.sendAfter; 
							t.childCampaign.send_after_type = this.sendAfterType;
							campaign_id = t.id;  
							send_at = t.send_at;
						}
						if(t.childCampaign.childCampaign && t.childCampaign.childCampaign.send_after && t.childCampaign.childCampaign.send_after_type
						) {
							if(t.childCampaign.childCampaign.id == id) {
								oldCampaign = _.clone(t.childCampaign.childCampaign);
								t.childCampaign.childCampaign.send_after = this.sendAfter;
								t.childCampaign.childCampaign.send_after_type = this.sendAfterType;
								campaign_id = t.id;  
								send_at = t.send_at;
							}
						}
					}
				});

				var send_at_end;
				var send_at_start;
				_.map(campaignsDetails,(t)=>{
					if(t.id == campaign_id) {
						let add_days = parseInt(t.end_days);
						let add_hours = 0;
						if(t.childCampaign && t.childCampaign.send_after && t.childCampaign.send_after_type) {
						
							if(t.childCampaign.send_after_type == 1) {
								add_days += parseInt(t.childCampaign.send_after);
							} else {
								add_hours += parseInt(t.childCampaign.send_after);
							}
							add_days += parseInt(t.childCampaign.end_days);
						
							if(t.childCampaign.childCampaign && t.childCampaign.childCampaign.send_after && t.childCampaign.childCampaign.send_after_type
							) {
									if(t.childCampaign.childCampaign.send_after_type == 1) {
										add_days += parseInt(t.childCampaign.childCampaign.send_after);
									} else {
										add_hours += parseInt(t.childCampaign.childCampaign.send_after);
									}
									add_days += parseInt(t.childCampaign.childCampaign.end_days);
							}
						}
						send_at_start = this.moment(t.send_at).format('Y-MM-DD HH:mm:ss');
						send_at_end = this.moment(t.send_at).add(add_days,'day').add(add_hours,'hours').format('Y-MM-DD HH:mm:ss');
					}
				});

				_.map(campaignsDetails,(t)=>{
					if(t.id != campaign_id) {
						let beforeTime = this.moment(t.send_at);
						let add_days = parseInt(t.end_days);
						let add_hours = 0;
						if(t.childCampaign && t.childCampaign.send_after && t.childCampaign.send_after_type
						) {
							if(t.childCampaign.send_after_type == 1) {
								add_days += parseInt(t.childCampaign.send_after);
							} else {
								add_hours += parseInt(t.childCampaign.send_after);
							}
							add_days += parseInt(t.childCampaign.end_days);

							if(t.childCampaign.childCampaign && t.childCampaign.childCampaign.send_after && t.childCampaign.childCampaign.send_after_type
							) {
								if(t.childCampaign.childCampaign.send_after_type == 1) {
									add_days += parseInt(t.childCampaign.childCampaign.send_after);
								} else {
									add_hours += parseInt(t.childCampaign.childCampaign.send_after);
								}
								add_days += parseInt(t.childCampaign.childCampaign.end_days);
							}
						}

						let afterTime = this.moment(t.send_at).add(add_days,'day').add(add_hours,'hours');
						if (this.moment(send_at_end).isBetween(beforeTime, afterTime) || this.moment(send_at_start).isBetween(beforeTime, afterTime) || this.moment(beforeTime).isBetween(send_at_start, send_at_end)) {
							this.dateconflicterrormessage =true;
							return;
						}
					}
				});

				if(this.dateconflicterrormessage == true){
					setTimeout(()=>{
						this.sendAfter = oldCampaign.send_after;
						this.sendAfterType = oldCampaign.send_after_type;
						this.dateconflicterrormessage = false;
					},3000);
					return;
				}

				let data =
					{
						send_after: this.sendAfter,
						send_after_type: this.sendAfterType,
						action: this.campaignAction,
						id: id
					}
				this.$http.post('/bulk/campaign/schedulecampaign/bulkedit', data).then((response) => {
					$('#update_campaign_schedule_' + id).modal('hide');
					this.campaign.send_after = response.data.data.send_after;
					this.campaign.send_after_type = response.data.data.send_after_type;
					let campaign = response.data.data;
					this.$parent.$emit('showUpdateSuccessFullMesssage');
					if (campaign.action && campaign.action != "") {
						this.ActionsValue = [];
						_.map(this.actionArry, (t) => {
							if (campaign.action.indexOf(t.value) != -1) {
								this.ActionsValue.push(t.label);
							}
						});
						this.ActionsValue = this.ActionsValue.join(', ');
					}

					if(this.campaignAction.indexOf('5') != -1) {
						// TODO:: need any action if user select 5 on already created campaign
					}

				});
				this.$parent.$emit('changeNextDaysFromChild', data);
			}
		},
		editScheduledCampaign(id) {
			this.$http.get('/bulk/campaign/' + id + '/schedulenew').then((response) => {
				this.previewCampaign = response.data.data[0];
				console.log(this.previewCampaign);
				this.showEditPopUp = true;
				this.$parent.$emit('showUpdateSuccessFullMesssage');
				setTimeout(function() {
					$('#editCampaign_' + id).modal('show');
				}, 10);
			});

		}
	}
}
</script>


 


// WEBPACK FOOTER //
// campaignScheduleCard.vue?2047ee22